import { render, staticRenderFns } from "./main-factors-actions.vue?vue&type=template&id=21530b64&scoped=true&"
import script from "./main-factors-actions.vue?vue&type=script&lang=js&"
export * from "./main-factors-actions.vue?vue&type=script&lang=js&"
import style0 from "./main-factors-actions.vue?vue&type=style&index=0&id=21530b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21530b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21530b64')) {
      api.createRecord('21530b64', component.options)
    } else {
      api.reload('21530b64', component.options)
    }
    module.hot.accept("./main-factors-actions.vue?vue&type=template&id=21530b64&scoped=true&", function () {
      api.rerender('21530b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/main-factors-actions.vue"
export default component.exports